module.exports = __webpack_public_path__ + "img/btn1@2x.74ca82e9.png";